
<div class="popupu_card ci_popup_card pop_active_card" id="divPlanRejectionReasonPopup" *ngIf="show">

  <div class="popup_inner">

      <a href="javascript:void(0)" (click)="planRejectionReasonCancel()" class="pc_close_btn"><i class="icon-close"></i></a>

      <div class="ci_popup_txt_area">

          <p class="cpta_img cpi_sm"><img src="assets/images/rejection_icon.svg" alt=""></p>
              <h2>Accompany Rejection Reason</h2>

              <div class="mdc_date_tbox">

                  <div class="lcta_tbox"  [ngClass]="{'error': this.state.rejectionreason.iserr}">
                
                      <div class="lct_slt">
  
                          <select [(ngModel)]=this.state.rejectionreason.value id="drprejectionreason" (click)="drprejectionreason_Click()">
      
                              <option value="0">Select reason</option>
                              <ng-container *ngFor="let obj of this.rejectionreasonList">
                              
                              <option value="{{obj.reason_id}}">{{obj.reason}}</option>
                              
                              </ng-container>
      
                          </select>               
                  
                  
                      </div>
                  
                      <span class="error_txt">{{this.state.rejectionreason.err_txt}}</span>
  
                  </div>
  
                  <div class="textarea_card" [ngClass]="{'error': this.state.rejectionreasonComments.iserr}">
  
                      <textarea name="" [(ngModel)]=this.state.rejectionreasonComments.value placeholder="Reason"
                      (click)="this.state.rejectionreasonComments.iserr=false"
                      cols="30" rows="10" ></textarea>
                      <span class="error_txt">{{this.state.rejectionreasonComments.err_txt}}</span>
                  </div>
                  
              </div>
          
      </div>

      <div class="ci_popup_btn_area">

          <button (click)="planRejectionReasonCancel()">CANCEL</button>

          <button (click)="planRejectionReasonYes()">SUBMIT</button>

      </div>

  </div>

</div>  